"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
var React = require("react");
var List_style_1 = require("./List.style");
var helpers_1 = require("../../../helpers");
var List = /** @class */ (function (_super) {
    __extends(List, _super);
    function List() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    List.prototype.render = function () {
        var _a = this.props, title = _a.title, yourTeam = _a.yourTeam, _b = _a.ranking, ranking = _b === void 0 ? 0 : _b, _c = _a.value, value = _c === void 0 ? 0 : _c, isDesktop = _a.isDesktop, participants = _a.participants;
        return (React.createElement(List_style_1.default.Wrap, { isDesktop: isDesktop, className: yourTeam === title ? 'team' : undefined },
            React.createElement(List_style_1.default.Id, null, yourTeam === title ? (React.createElement("span", null,
                React.createElement("b", null, helpers_1.prettifyIfNumber(ranking)))) : (React.createElement("span", null, helpers_1.prettifyIfNumber(ranking)))),
            React.createElement(List_style_1.default.Title, null, yourTeam === title ? React.createElement("b", null, title) : "" + title),
            participants ? (React.createElement(List_style_1.default.Participants, null, yourTeam === title ? (React.createElement("b", null, helpers_1.prettifyIfNumber(participants))) : (helpers_1.prettifyIfNumber(participants)))) : null,
            React.createElement(List_style_1.default.Value, null, helpers_1.prettifyIfNumber(value))));
    };
    return List;
}(React.Component));
exports.List = List;
exports.default = List;
//# sourceMappingURL=List.js.map